<div class="flex flex-col gap-4">
  <!-- Skeleton Loader View when API call is going -->
  <ng-container *ngIf="isLoading || isLoadingTasks; else mainContent">
    <div class="framework-details-container p-4">
      <!-- Header Card Skeleton -->
      <div
        class="header-card flex flex-col md:flex-row md:items-center justify-between gap-6 mb-6"
      >
        <div class="flex items-start gap-4 min-w-0 flex-1">
          <div class="sk-box w-16 h-8 rounded-lg shrink-0"></div>

          <!-- Circular Logo Skeleton -->
          <div class="sk-box w-10 h-10 rounded-full shrink-0"></div>

          <!-- Title & Details Skeleton -->
          <div class="min-w-0 flex-1">
            <div class="flex flex-wrap items-center gap-3 mb-2">
              <div class="sk-box w-36 h-5 rounded"></div>
              <div class="sk-box w-14 h-4 rounded"></div>
            </div>
            <div class="sk-box w-64 md:w-96 h-3.5 rounded"></div>
          </div>
        </div>

        <!-- Top Action Buttons Skeleton -->
        <div class="flex items-center gap-3 shrink-0">
          <div class="sk-box w-36 h-8 rounded-lg"></div>
        </div>
      </div>

      <!-- Summary Metrics Cards Grid Skeleton -->
      <div class="metrics-grid mb-1 w-full">
        <!-- Deployed Card Skeleton -->
        <div
          class="metric-card card-na p-3.5 sm:p-4 rounded-xl flex items-center gap-3.5 min-w-0"
        >
          <div class="sk-box w-10 h-10 rounded-xl shrink-0"></div>
          <div class="flex flex-col min-w-0 flex-1">
            <div class="sk-box w-8 h-6 rounded mb-1.5"></div>
            <div class="sk-box w-20 h-3.5 rounded"></div>
          </div>
        </div>

        <!-- Verified Card Skeleton -->
        <div
          class="metric-card card-na p-3.5 sm:p-4 rounded-xl flex items-center gap-3.5 min-w-0"
        >
          <div class="sk-box w-10 h-10 rounded-xl shrink-0"></div>
          <div class="flex flex-col min-w-0 flex-1">
            <div class="sk-box w-8 h-6 rounded mb-1.5"></div>
            <div class="sk-box w-20 h-3.5 rounded"></div>
          </div>
        </div>

        <!-- Audited Card Skeleton -->
        <div
          class="metric-card card-na p-3.5 sm:p-4 rounded-xl flex items-center gap-3.5 min-w-0"
        >
          <div class="sk-box w-10 h-10 rounded-xl shrink-0"></div>
          <div class="flex flex-col min-w-0 flex-1">
            <div class="sk-box w-8 h-6 rounded mb-1.5"></div>
            <div class="sk-box w-20 h-3.5 rounded"></div>
          </div>
        </div>

        <!-- Not Applicable Card Skeleton -->
        <div
          class="metric-card card-na p-3.5 sm:p-4 rounded-xl flex items-center gap-3.5 min-w-0"
        >
          <div class="sk-box w-10 h-10 rounded-xl shrink-0"></div>
          <div class="flex flex-col min-w-0 flex-1">
            <div class="sk-box w-8 h-6 rounded mb-1.5"></div>
            <div class="sk-box w-20 h-3.5 rounded"></div>
          </div>
        </div>

        <!-- Score Circular Radial Card Skeleton -->
        <div
          class="metric-card card-na p-3.5 sm:p-4 rounded-xl flex items-center gap-3.5 min-w-0"
        >
          <div class="sk-box w-10 h-10 rounded-xl shrink-0"></div>
          <div class="flex flex-col min-w-0 flex-1">
            <div class="sk-box w-8 h-6 rounded mb-1.5"></div>
            <div class="sk-box w-20 h-3.5 rounded"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="framework-details-container p-4">
      <!-- Search & Filters Row Skeleton -->
      <div
        class="filters-row flex flex-col justify-end me-auto lg:flex-row lg:items-center gap-4 mb-4 p-4 rounded-xl"
      >
        <div class="sk-box w-36 h-5 rounded me-auto"></div>
        <div class="flex flex-wrap items-center gap-3">
          <div class="sk-box w-48 h-8 rounded-lg"></div>
          <div class="sk-box w-28 h-8 rounded-lg"></div>
          <div class="sk-box w-28 h-8 rounded-lg"></div>
        </div>
      </div>

      <!-- Tasks Table Card Skeleton -->
      <div class="table-card border rounded-xl overflow-hidden mb-2">
        <div class="overflow-x-auto">
          <table class="w-full text-left text-2xs border-collapse">
            <thead>
              <tr
                class="table-header-row border-b border-gray-200 dark:border-gray-800"
              >
                <th class="p-3 w-10"></th>
                <th class="p-3">TASK NAME</th>
                <th class="p-3 text-center">WEIGHTAGE</th>
                <th class="p-3">DUE DATE</th>
                <th class="p-3 text-center">ASSIGNED TO</th>
                <th class="p-3">PROGRESS</th>
                <th class="p-3 text-center">STATUS</th>
                <th class="p-3 text-center">PRIORITY</th>
                <th class="p-3 text-center">RISK</th>
                <th class="p-3 w-10 text-center">ACTION</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let row of [1, 2, 3, 4, 5]"
                class="border-b border-gray-100 dark:border-gray-800/60 p-3"
              >
                <td class="p-3"><div class="sk-box w-4 h-4 rounded"></div></td>
                <td class="p-3">
                  <div class="flex items-center gap-3">
                    <div class="sk-box w-7 h-7 rounded-lg shrink-0"></div>
                    <div class="flex flex-col gap-1.5 flex-1">
                      <div class="sk-box w-24 h-3 rounded"></div>
                      <div class="sk-box w-44 h-3.5 rounded"></div>
                    </div>
                  </div>
                </td>
                <td class="p-3 text-center">
                  <div class="sk-box w-6 h-4 rounded mx-auto"></div>
                </td>
                <td class="p-3">
                  <div class="flex flex-col gap-1">
                    <div class="sk-box w-20 h-3 rounded"></div>
                    <div class="sk-box w-14 h-2.5 rounded"></div>
                  </div>
                </td>
                <td class="p-3 text-center">
                  <div class="sk-box w-7 h-7 rounded-full mx-auto"></div>
                </td>
                <td class="p-3">
                  <div class="flex items-center gap-2 w-28">
                    <div class="sk-box h-2 rounded-full flex-1"></div>
                    <div class="sk-box w-7 h-3 rounded"></div>
                  </div>
                </td>
                <td class="p-3 text-center">
                  <div class="sk-box w-16 h-5 rounded-full mx-auto"></div>
                </td>
                <td class="p-3 text-center">
                  <div class="sk-box w-16 h-5 rounded-full mx-auto"></div>
                </td>
                <td class="p-3 text-center">
                  <div class="sk-box w-14 h-5 rounded-full mx-auto"></div>
                </td>
                <td class="p-3 text-center">
                  <div class="sk-box w-4 h-4 rounded mx-auto"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #mainContent>
    <div class="framework-details-container p-4">
      <!-- Header Card (Logo, Description, Actions) -->
      <div
        class="header-card flex flex-col md:flex-row md:items-center justify-between gap-6 mb-6"
      >
        <div class="flex items-start gap-4 min-w-0 flex-1">
          <button (click)="back.emit()" class="btn-back flex-shrink-0">
            <i class="ki-filled ki-left"></i> Back
          </button>

          <!-- Circular Logo -->
          <div class="logo-circle flex-shrink-0">
            <img
              [src]="getFrameworkIconUrl(framework)"
              [alt]="framework?.shortName || 'Framework'"
              (error)="onIconError(framework, $event)"
            />
          </div>

          <!-- Title & Details -->
          <div class="min-w-0 flex-1">
            <div class="flex flex-wrap items-center gap-3">
              <h2 class="text-md text-gray-800 dark:text-white font-medium">
                {{ framework?.shortName }}
              </h2>
              <span *ngIf="framework?.category" class="category-badge">
                {{ framework.category }}
              </span>
            </div>
            <p
              class="text-xs text-gray-500 dark:text-gray-400 mt-1 break-words"
            >
              {{ framework?.fullName }}
            </p>
          </div>
        </div>

        <!-- Top Action Buttons -->
        <div
          class="flex items-center gap-3 flex-shrink-0"
          *ngIf="isWriteAccess"
        >
          <button
            *ngIf="framework?.isSelected"
            (click)="toggleFrameworkSelection(false)"
            [disabled]="isSavingSelection"
            class="btn-deselect flex items-center gap-2 font-semibold px-4 py-2 rounded-lg text-xs transition-all cursor-pointer disabled:opacity-50"
          >
            <i class="ki-outline ki-trash"></i> Deselect Framework
          </button>

          <button
            *ngIf="!framework?.isSelected"
            (click)="toggleFrameworkSelection(true)"
            [disabled]="isSavingSelection"
            class="btn-select flex items-center gap-2 font-semibold px-4 py-2 rounded-lg text-xs transition-all cursor-pointer disabled:opacity-50"
          >
            <i class="ki-outline ki-plus"></i> Select Framework
          </button>
        </div>
      </div>

      <!-- Summary Metrics Cards Grid -->
      <div class="metrics-grid mb-1 w-full">
        <!-- Deployed Card -->
        <div
          class="metric-card card-deployed p-3.5 sm:p-4 rounded-xl flex items-center gap-3.5 min-w-0"
        >
          <div
            class="icon-wrapper deployed flex items-center justify-center text-lg"
          >
            <i class="ki-outline ki-check-circle"></i>
          </div>
          <div class="flex flex-col min-w-0">
            <span class="metric-val deployed-color font-bold">
              {{ deployedCount }}
            </span>
            <span class="metric-label font-medium text-gray-600">Deployed</span>
          </div>
        </div>

        <!-- Verified Card -->
        <div
          class="metric-card card-verified p-3.5 sm:p-4 rounded-xl flex items-center gap-3.5 min-w-0"
        >
          <div class="icon-wrapper verified flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              class="w-5 h-5"
              fill="currentColor"
            >
              <path
                d="m8.6 22.5l-1.9-3.2l-3.6-.8l.35-3.7L1 12l2.45-2.8l-.35-3.7l3.6-.8l1.9-3.2L12 2.95l3.4-1.45l1.9 3.2l3.6.8l-.35 3.7L23 12l-2.45 2.8l.35 3.7l-3.6.8l-1.9 3.2l-3.4-1.45zm.85-2.55l2.55-1.1l2.6 1.1l1.4-2.4l2.75-.65l-.25-2.8l1.85-2.1l-1.85-2.15l.25-2.8l-2.75-.6l-1.45-2.4L12 5.15l-2.6-1.1L8 6.45l-2.75.6l.25 2.8L3.65 12l1.85 2.1l-.25 2.85l2.75.6zm1.5-4.4L16.6 9.9l-1.4-1.45l-4.25 4.25l-2.15-2.1L7.4 12z"
              />
            </svg>
          </div>
          <div class="flex flex-col min-w-0">
            <span class="metric-val verified-color font-bold">
              {{ verifiedCount }}
            </span>
            <span class="metric-label font-medium text-gray-600">Verified</span>
          </div>
        </div>

        <!-- Audited Card -->
        <div
          class="metric-card card-audited p-3.5 sm:p-4 rounded-xl flex items-center gap-3.5 min-w-0"
        >
          <div class="icon-wrapper audited flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              class="w-5 h-5"
              fill="currentColor"
            >
              <path
                d="M15 13.5c0-1.93-1.57-3.5-3.5-3.5S8 11.57 8 13.5S9.57 17 11.5 17c.6 0 1.16-.17 1.65-.43l2.14 2.14l1.41-1.41l-2.14-2.14c.27-.49.43-1.05.43-1.65Zm-5 0c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5"
              ></path>
              <path
                d="m19.94 7.68l-.03-.09a.8.8 0 0 0-.2-.29l-5-5c-.09-.09-.19-.15-.29-.2l-.09-.03a.8.8 0 0 0-.27-.05c-.02 0-.04-.01-.06-.01H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-12s-.01-.04-.01-.06c0-.09-.02-.17-.05-.26ZM6 20V4h7v4c0 .55.45 1 1 1h4v11z"
              ></path>
            </svg>
          </div>
          <div class="flex flex-col">
            <span class="metric-val audited-color font-bold">
              {{ auditedCount }}
            </span>
            <span class="metric-label font-medium text-gray-600">Audited</span>
          </div>
        </div>
        <!-- Not Applicable Card -->
        <div
          class="metric-card card-na p-3.5 sm:p-4 rounded-xl flex items-center gap-3.5 min-w-0"
        >
          <div class="icon-wrapper na flex items-center justify-center text-lg">
            <i class="ki-outline ki-minus"></i>
          </div>
          <div class="flex flex-col min-w-0">
            <span class="metric-val na-color font-bold">
              {{ notApplicableCount }}
            </span>
            <span class="metric-label font-medium text-gray-600"
              >Not Applicable</span
            >
          </div>
        </div>

        <!-- Score Circular Radial Card -->
        <div
          class="metric-card card-score p-3.5 sm:p-4 rounded-xl flex items-center justify-between min-w-0"
        >
          <div class="flex flex-col">
            <span class="score-val font-bold"
              >{{ framework?.completedPercent || 0 | number: "1.2-2" }}%</span
            >
            <span
              class="score-label text-gray-600 font-medium tracking-wide mt-0.5"
              >Framework Readiness</span
            >
          </div>
          <div
            class="score-donut-wrapper relative w-12 h-12 flex items-center justify-center flex-shrink-0"
          >
            <svg class="w-full h-full" viewBox="0 0 48 48">
              <path
                class="circle-bg"
                stroke-width="3"
                fill="transparent"
                d="M 24 4 a 20 20 0 0 1 0 40 a 20 20 0 0 1 0 -40"
              />
              <path
                class="circle-progress"
                stroke-width="3"
                fill="transparent"
                stroke-linecap="round"
                [attr.stroke-dasharray]="
                  (125.6 * (framework?.completedPercent || 0)) / 100 + ', 125.6'
                "
                d="M 24 4 a 20 20 0 0 1 0 40 a 20 20 0 0 1 0 -40"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div class="framework-details-container p-4">
      <!-- Search & Filters Row -->
      <div
        class="filters-row flex flex-col justify-end me-auto lg:flex-row lg:items-center gap-4 mb-4 p-4 rounded-xl"
      >
        <span
          class="text-md font-semibold text-gray-800 dark:text-white me-auto flex justify-center items-center"
          >Related Tasks ({{ totalFilteredCount }})</span
        >
        <!-- Left side: Search & Dropdowns -->
        <div class="flex flex-wrap items-center gap-3">
          <!-- Search bar -->
          <div class="search-wrapper">
            <i class="ki-filled ki-magnifier"></i>
            <input
              #search
              type="text"
              [value]="searchQuery"
              (input)="onSearchInput(search.value)"
              placeholder="Search tasks..."
              class="filter-input w-full rounded-lg py-2 pr-4 text-xs focus:outline-none"
            />
            <button
              *ngIf="search.value"
              type="button"
              class="clear-btn text-xl"
              (click)="clearSearch(search)"
            >
              ×
            </button>
          </div>

          <!-- Status Filter -->
          <select
            [(ngModel)]="selectedStatus"
            (ngModelChange)="onFilterChange()"
            class="filter-select rounded-lg px-3 py-2 text-xs focus:outline-none cursor-pointer"
          >
            <option>All Status</option>
            <option>Audited</option>
            <option>Verified</option>
            <option>Deployed</option>
            <option>To Do</option>
            <option>Compensated</option>
            <option>Not Applicable</option>
          </select>

          <!-- Priority Filter -->
          <select
            [(ngModel)]="selectedPriority"
            (ngModelChange)="onFilterChange()"
            class="filter-select rounded-lg px-3 py-2 text-xs focus:outline-none cursor-pointer"
          >
            <option>All Priority</option>
            <option>Do Now</option>
            <option>Do Soon</option>
            <option>Do Later</option>
          </select>
        </div>
      </div>

      <!-- Tasks Table Card -->
      <div
        class="table-card border rounded-xl overflow-hidden mb-2"
        *ngIf="filteredTasks.length > 0; else noTasksTemplate"
      >
        <app-task-table
          [formData]="taskTableData"
          [isWriteAccess]="false"
          [isLoading]="isLoadingTasks"
          [taskAssigned]="''"
          [selectedIds]="selectedIds"
          [tasksLimit]="pageSize"
          (loadData)="handleTableLoadData($event)"
          (selectionChanged)="handleSelection($event)"
          [showHeader]="false"
        ></app-task-table>
      </div>

      <ng-template #noTasksTemplate>
        <div
          class="empty-state-card border rounded-xl p-8 mb-6 flex flex-col items-center justify-center text-center"
        >
          <div
            class="empty-state-icon-wrapper mb-4 flex items-center justify-center"
          >
            <i class="ki-filled ki-file-sheet text-3xl"></i>
          </div>
          <h4
            class="empty-state-title font-bold text-base text-gray-800 dark:text-white mb-1"
          >
            No Tasks Found
          </h4>
          <p class="empty-state-desc text-xs text-gray-500 max-w-sm">
            There are no compliance tasks available for this framework matching
            your current filters.
          </p>
        </div>
      </ng-template>

      <!-- Confirmation Modal -->
      <div
        class="modal"
        data-modal="true"
        data-modal-disable-scroll="false"
        id="confirm_modal"
      >
        <div
          class="modal-content break-words my-5 sm:rounded-lg shadow-lg max-w-[600px] w-full bg-white dark:bg-coal-500 mx-auto"
        >
          <div class="modal-header flex justify-between items-center p-4">
            <span class="font-semibold text-base ms-2 card-title">
              {{ confirmTitle }}
            </span>
          </div>

          <div class="modal-body gap-5 p-4">
            <div class="flex flex-col items-center text-center gap-2">
              <div
                class="icon-warning-wrapper flex items-center justify-center text-5xl mb-4"
              >
                <i class="ki-filled ki-information-2 text-warning text-5xl"></i>
              </div>
              <span class="text-md font-semibold text-gray-800 mt-4"
                >Confirmation</span
              >
              <p
                class="modal-body-text text-sm text-gray-700 dark:text-gray-300 mb-6 leading-relaxed"
                [innerHTML]="confirmMessage"
              ></p>
            </div>
            <div
              class="modal-footer pt-4 px-4 flex justify-center border-t border-gray-100 dark:border-gray-700 gap-3"
            >
              <button
                type="button"
                class="btn btn-sm btn-secondary cancel-modal-btn"
                (click)="cancelSelectionToggle()"
              >
                Cancel
              </button>
              <button
                type="submit"
                class="btn btn-sm btn-primary btn-brand-primary"
                (click)="confirmSelectionToggle()"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
